module.exports = __webpack_public_path__ + "img/duncana.2a40f712.jpg";